import React, { createContext, useContext } from 'react';

const DashboardContext = createContext(false);

export const useIsInDashboard = () => useContext(DashboardContext);

export const DashboardShell = ({ children }) => (
  <DashboardContext.Provider value={true}>
    {children}
  </DashboardContext.Provider>
);

export default DashboardContext;
